import { FormEvent } from 'react';

export default function PaymentPayButton({
  title,
  selected,
  onClick,
}: {
  title: string;
  selected: boolean;
  onClick: (e: FormEvent) => void;
}): JSX.Element {
  return (
    <div
      className={[
        'box-border',
        'rounded-sm',
        'flex',
        'items-center',
        'justify-center',
        'w-full',
        'border-2',
        selected ? 'border-bluey-purple' : 'border-transparent',
      ].join(' ')}
    >
      <button
        className={[
          'rounded-sm',
          'flex',
          'items-center',
          'justify-center',
          'w-full',
          'h-12',
          // 'py-4',
          'border',
          selected ? 'N_14_M text-bluey-purple' : 'N_14_R text-greyish-brown',
          selected ? 'border-transparent' : 'border-very-light-grey',
        ].join(' ')}
        onClick={onClick}
      >
        {title}
      </button>
    </div>
  );
}
